import { render, staticRenderFns } from "./BaseButtonSchemaSelect.vue?vue&type=template&id=4f257eda&scoped=true&"
import script from "./BaseButtonSchemaSelect.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSchemaSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSchemaSelect.vue?vue&type=style&index=0&id=4f257eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f257eda",
  null
  
)

export default component.exports